/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CustomerPawningContractResponse = {
    customerFirstName?: string;
    customerLastName?: string;
    customerPhone?: string;
    pawnedAt?: string;
    dueDate?: string;
    dueAmount?: number;
    redemptionAmount?: number;
    shopId?: string;
    shopName?: string;
    shopLineId?: string;
    shopFacebookId?: string;
    shopLogoUrl?: string;
    pawningStatus?: CustomerPawningContractResponse.pawningStatus;
};
export namespace CustomerPawningContractResponse {
    export enum pawningStatus {
        ONGOING = 'ONGOING',
        REDEEMED = 'REDEEMED',
        FORECLOSURE = 'FORECLOSURE',
    }
}

